import PropTypes from 'prop-types'
import SelectComponent from 'components/common/SelectComponent'

const LabeledSelectComponent = ({
  label,
  name,
  onChange,
  children,
  required = false,
  missingFields = [],
  ...rest
}) => {
  const isMissing = missingFields?.includes?.(name) || missingFields?.has?.(name)

  return (
    <div>
      <label htmlFor={rest?.id || name} className='block text-sm font-medium text-gray-700'>
        {label}{required && ' *'}
      </label>
      <SelectComponent
        name={name}
        onChange={onChange}
        className={`mt-1 ${isMissing ? 'border-orange-500' : ''}`}
        {...rest}
      >
        <option key='' value=''>Select Option</option>
        {children}
      </SelectComponent>
    </div>
  )
}

LabeledSelectComponent.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  isFieldMissing: PropTypes.func,
  children: PropTypes.node,
  missingFields: PropTypes.array
}

LabeledSelectComponent.defaultProps = {
  required: false,
  isFieldMissing: () => false,
  missingFields: []
}

export default LabeledSelectComponent
